import React from 'react'

import SuggestionContainer from '../components/suggestion/SuggestionContainer'

const SuggestionScreen = props => <SuggestionContainer {...props} />

export default SuggestionScreen
